import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider } from './contexts/AuthContext';
import { SnackbarProvider } from 'notistack';
import theme from './theme';
import PrivateRoute from './components/PrivateRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import Dashboard from './pages/Dashboard';
import Productos from './pages/inventario/Productos';
import ProductoForm from './pages/inventario/ProductoForm';
import Transferencias from './pages/inventario/Transferencias';
import AjusteInventarioForm from './pages/inventario/AjusteInventarioForm';
import Ramos from './pages/inventario/Ramos';
import RamoForm from './pages/inventario/RamoForm';
import Lineas from './pages/inventario/Lineas';
import LineaForm from './pages/inventario/LineaForm';
import Clases from './pages/inventario/Clases';
import ClaseForm from './pages/inventario/ClaseForm';
import Devoluciones from './pages/inventario/Devoluciones';
import Produccion from './pages/inventario/Produccion';
import Picking from './pages/inventario/Picking';
import ConteoStock from './pages/inventario/ConteoStock';
import Recibos from './components/Tesoreria/Recibos';
import NuevoRecibo from './components/Tesoreria/NuevoRecibo';
import OrdenPago from './components/Tesoreria/OrdenPago';
import NuevaOrdenPago from './components/Tesoreria/NuevaOrdenPago';
import MovimientosVarios from './components/Tesoreria/MovimientosVarios';
import MovimientosBancarios from './components/Tesoreria/MovimientosBancarios';
import NuevoMovimientoCaja from './components/Tesoreria/NuevoMovimientoCaja';
import Bancos from './pages/tesoreria/Bancos';
import BancoForm from './pages/tesoreria/BancoForm';
import Carteras from './pages/tesoreria/Carteras';
import CarteraForm from './pages/tesoreria/CarteraForm';
import GruposMcp from './pages/tesoreria/GruposMcp';
import GrupoMcpForm from './pages/tesoreria/GrupoMcpForm';
import MarcasTarjetas from './pages/tesoreria/MarcasTarjetas';
import MarcaTarjetaForm from './pages/tesoreria/MarcaTarjetaForm';
import MovimientosCaja from './pages/tesoreria/MovimientosCaja';
import TesoreriaInformes from './pages/tesoreria/Informes';
import ChequesTercero from './pages/tesoreria/ChequesTercero';
import ChequesTercerosCartera from './pages/tesoreria/ChequesTercerosCartera';
import ChequesPropios from './pages/tesoreria/ChequesPropios';
import ChequesPropiosPendientesAcreditar from './pages/tesoreria/ChequesPropiosPendientesAcreditar';
import Disponibilidades from './pages/tesoreria/Disponibilidades';
import MovimientosCarteras from './pages/tesoreria/MovimientosCarteras';
import TesoreriaTransferencias from './pages/tesoreria/Transferencias';
import ConsultasPage from './pages/ConsultasPage';
import StockPorDeposito from './pages/inventario/StockPorDeposito';
import Informes from './pages/inventario/Informes';
import MovimientosStock from './pages/inventario/MovimientosStock';
import Clientes from './pages/Clientes';
import ClienteForm from './pages/ClienteForm';
import Proveedores from './pages/inventario/Proveedores';
import ProveedorForm from './pages/inventario/ProveedorForm';
import Pedidos from './pages/pedidoventa/Pedidos';
import PedidosVenta from './pages/pedidoventa/index';
import Cotizaciones from './pages/cotizacionventa/Cotizaciones';
import CotizacionesVenta from './pages/cotizacionventa/index';
import NuevaFacturaVenta from './pages/facturaventa/index';
import VentasInformes from './pages/ventas/Informes';
import CuentasPorCobrar from './pages/ventas/CuentasPorCobrar';
import ResumenCuentaVentas from './pages/ventas/ResumenCuenta';
import Facturas from './pages/ventas/Facturas';
import NotasCredito from './pages/ventas/NotasCredito';
import NuevaNotaCredito from './pages/ventas/NuevaNotaCredito';
import LibroIvaVentas from './pages/ventas/LibroIvaVentas';
import ComprasInformes from './pages/compras/Informes';
import CuentasPorPagar from './pages/compras/CuentasPorPagar';
import ResumenCuenta from './pages/compras/ResumenCuenta';
import LibroIvaCompras from './pages/compras/LibroIvaCompras';
import FacturasCompra from './pages/compras/FacturasCompra';
import FacturaCompraForm from './pages/compras/FacturaCompraForm';
import FacturaCompraDetalle from './pages/compras/FacturaCompraDetalle';
import Usuarios from './pages/sistema/Usuarios';
import UsuarioForm from './pages/sistema/UsuarioForm';
import TipoFormulario from './pages/sistema/TipoFormulario';
import TipoFormularioForm from './pages/sistema/TipoFormularioForm';
import Provincias from './pages/sistema/Provincias';
import ProvinciaForm from './pages/sistema/ProvinciaForm';
import Localidades from './pages/sistema/Localidades';
import LocalidadForm from './pages/sistema/LocalidadForm';
import MovMoneda from './pages/sistema/MovMoneda';
import MovMonedaForm from './pages/sistema/MovMonedaForm';
import Companias from './pages/sistema/Companias';
import CompaniaForm from './pages/sistema/CompaniaForm';
import CajaxUsuario from './pages/sistema/CajaxUsuario';
import CajaUsuarioForm from './pages/sistema/CajaUsuarioForm';
import GrupoMcpUsuarioPage from './pages/sistema/GrupoMcpUsuario';
import GrupoMcpUsuarioForm from './pages/sistema/GrupoMcpUsuarioForm';
import Vendedores from './pages/ventas/Vendedores';
import VendedorForm from './pages/ventas/VendedorForm';
import Rutas from './pages/ventas/Rutas';
import RutaForm from './pages/ventas/RutaForm';
import ListaPrecios from './pages/ventas/ListaPrecios';
import ListaPrecioForm from './pages/ventas/ListaPrecioForm';
import ArticuloXListaPrecio from './pages/ventas/ArticuloXListaPrecio';
import ArticuloXListaPrecioForm from './pages/ventas/ArticuloXListaPrecioForm';
import RamosProv from './pages/compras/RamosProv';
import RamosProvForm from './pages/compras/RamosProvForm';
import Transportes from './pages/configuraciones/Transportes';
import TransporteForm from './pages/configuraciones/TransporteForm';
import Impuestos from './pages/configuraciones/Impuestos';
import ImpuestoForm from './pages/configuraciones/ImpuestoForm';
import Ubicaciones from './pages/configuraciones/Ubicaciones';
import UbicacionForm from './pages/configuraciones/UbicacionForm';
import SucVenta from './pages/configuraciones/SucVenta';
import SucVentaForm from './pages/configuraciones/SucVentaForm';
import SucursalesVenta from './pages/configuraciones/SucursalesVenta';
import SucursalVentaForm from './pages/configuraciones/SucursalVentaForm';
import Imputables from './pages/contabilidad/Imputables';
import ImputableForm from './pages/contabilidad/ImputableForm';
import NoImputables from './pages/contabilidad/NoImputables';
import NoImputableForm from './pages/contabilidad/NoImputableForm';
import Estrategia from './pages/contabilidad/Estrategia';
import EstrategiaForm from './pages/contabilidad/EstrategiaForm';

import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { buildInfo } from './config/buildInfo';

const App: React.FC = () => {

  const [deferredPrompt, setDeferredPrompt] = useState<any>(null);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [showInstallButton, setShowInstallButton] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [updateAvailable, setUpdateAvailable] = useState(false);
    const [waitingWorker, setWaitingWorker] = useState<ServiceWorkerRegistration | null>(null);
    const [postUpdateVersion, setPostUpdateVersion] = useState<string | null>(null);
    const [isUpdating, setIsUpdating] = useState(false);

useEffect(() => {
        const handleBeforeInstallPrompt = (e: any) => {
            e.preventDefault(); // Previene que el navegador muestre el prompt automáticamente
            setDeferredPrompt(e);
            setShowInstallButton(true);
            setSnackbarOpen(true); // Mostrar Snackbar con botón
        };

        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

        return () => {
            window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
        };
    }, []);

    const handleInstallClick = async () => {
        if (deferredPrompt) {
            deferredPrompt.prompt();
            const choiceResult = await deferredPrompt.userChoice;
            console.log(`User response to the install prompt: ${choiceResult.outcome}`);
            setDeferredPrompt(null);
            setShowInstallButton(false);
            setSnackbarOpen(false);
        }
    };

    // Registrar service worker y verificar actualizaciones periódicamente
    useEffect(() => {
      // Verificar si hay un flag de actualización pendiente
      const updatingFlag = localStorage.getItem('appIsUpdating');
      if (updatingFlag) {
        setIsUpdating(true);
        // Limpiar el flag después de un breve delay para permitir que la actualización se complete
        setTimeout(() => {
          localStorage.removeItem('appIsUpdating');
          setIsUpdating(false);
        }, 3000);
      }

      const handleUpdate = (registration: ServiceWorkerRegistration) => {
        // Solo mostrar el mensaje si no estamos en proceso de actualización
        // Verificar el flag en tiempo real, no depender del closure
        const currentlyUpdating = localStorage.getItem('appIsUpdating');
        if (!currentlyUpdating) {
          setUpdateAvailable(true);
          setWaitingWorker(registration);
        }
      };

      serviceWorkerRegistration.register({
        onUpdate: handleUpdate,
        onSuccess: () => {
          console.log('Service Worker registrado correctamente');
        }
      });

      // Verificar si ya hay un service worker esperando al cargar
      // Esperar un poco para que se limpie el flag si existe
      setTimeout(() => {
        const currentlyUpdating = localStorage.getItem('appIsUpdating');
        if ('serviceWorker' in navigator && !currentlyUpdating) {
          navigator.serviceWorker.ready.then((registration) => {
            // Solo mostrar si realmente hay uno esperando Y no estamos actualizando
            if (registration.waiting && !localStorage.getItem('appIsUpdating')) {
              setUpdateAvailable(true);
              setWaitingWorker(registration);
            }
          });
        }
      }, 1000);

      // Escuchar eventos de actualización del service worker
      if ('serviceWorker' in navigator) {
        const controllerChangeHandler = () => {
          // El service worker cambió, verificar si hay uno esperando
          // Pero solo si no estamos en proceso de actualización
          const currentlyUpdating = localStorage.getItem('appIsUpdating');
          if (!currentlyUpdating) {
            navigator.serviceWorker.ready.then((registration) => {
              if (registration.waiting && !localStorage.getItem('appIsUpdating')) {
                setUpdateAvailable(true);
                setWaitingWorker(registration);
              }
            });
          }
        };
        
        navigator.serviceWorker.addEventListener('controllerchange', controllerChangeHandler);
        
        return () => {
          navigator.serviceWorker.removeEventListener('controllerchange', controllerChangeHandler);
        };
      }

      // Verificar actualizaciones periódicamente (cada 2 minutos)
      const checkInterval = setInterval(() => {
        // Solo verificar si no estamos en proceso de actualización
        const currentlyUpdating = localStorage.getItem('appIsUpdating');
        if (!currentlyUpdating) {
          serviceWorkerRegistration.checkForUpdates();
        }
      }, 2 * 60 * 1000); // 2 minutos

      return () => {
        clearInterval(checkInterval);
      };
    }, []);

    useEffect(() => {
      const updatedVersion = localStorage.getItem('appUpdatedToVersion');
      if (updatedVersion) {
        setPostUpdateVersion(updatedVersion);
        localStorage.removeItem('appUpdatedToVersion');
      }
    }, []);

    const handleUpdateClick = async () => {
      // Marcar que estamos actualizando para evitar mostrar el mensaje nuevamente
      localStorage.setItem('appIsUpdating', 'true');
      setIsUpdating(true);
      setUpdateAvailable(false); // Ocultar el mensaje inmediatamente
      
      localStorage.setItem(
        'appUpdatedToVersion',
        `v${buildInfo.version} (build ${buildInfo.buildNumber})`
      );
      
      if (waitingWorker) {
        // Enviar mensaje al service worker para que se active
        waitingWorker.waiting?.postMessage({ type: 'SKIP_WAITING' });
        // Esperar un momento y luego recargar
        setTimeout(() => {
          window.location.reload();
        }, 100);
      } else {
        // Forzar recarga sin caché - limpiar todo
        try {
          // Desregistrar todos los service workers
          if ('serviceWorker' in navigator) {
            const registrations = await navigator.serviceWorker.getRegistrations();
            await Promise.all(registrations.map(reg => reg.unregister()));
          }
          
          // Limpiar todos los caches
          if ('caches' in window) {
            const cacheNames = await caches.keys();
            await Promise.all(cacheNames.map(name => caches.delete(name)));
          }
        } catch (error) {
          console.error('Error al limpiar cache:', error);
        }
        
        // Recargar sin cache
        window.location.reload();
      }
    };

    const handlePostUpdateClose = () => {
      setPostUpdateVersion(null);
    };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <SnackbarProvider maxSnack={3}>
        <AuthProvider>
          <Router>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route
                path="/"
                element={
                  <PrivateRoute>
                    <Layout />
                  </PrivateRoute>
                }
              >
                <Route index element={<Navigate to="/dashboard" replace />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="tesoreria">
                  <Route path="recibos" element={<Recibos />} />
                  <Route path="recibos/nuevo" element={<NuevoRecibo />} />
                  <Route path="orden-pago" element={<OrdenPago />} />
                  <Route path="orden-pago/nuevo" element={<NuevaOrdenPago />} />
                  <Route path="movimientos-varios" element={<MovimientosVarios />} />
                  <Route path="movimientos-varios/nuevo" element={<NuevoMovimientoCaja />} />
                  <Route path="movimientos-bancarios" element={<MovimientosBancarios />} />
                  <Route path="bancos" element={<Bancos />} />
                  <Route path="bancos/nuevo" element={<BancoForm />} />
                  <Route path="bancos/:nroBanco" element={<BancoForm />} />
                  <Route path="carteras" element={<Carteras />} />
                  <Route path="carteras/nuevo" element={<CarteraForm />} />
                  <Route path="carteras/:nroBanco" element={<CarteraForm />} />
                  <Route path="grupos-mcp" element={<GruposMcp />} />
                  <Route path="grupos-mcp/nuevo" element={<GrupoMcpForm />} />
                  <Route path="grupos-mcp/:grupoMcp" element={<GrupoMcpForm />} />
                  <Route path="tarjetas" element={<MarcasTarjetas />} />
                  <Route path="tarjetas/nuevo" element={<MarcaTarjetaForm />} />
                  <Route path="tarjetas/:codigoMarca" element={<MarcaTarjetaForm />} />
                  <Route path="movimientos-caja" element={<MovimientosCaja />} />
                  <Route path="disponibilidades" element={<Disponibilidades />} />
                  <Route path="transferencias" element={<TesoreriaTransferencias />} />
                  <Route path="informes" element={<TesoreriaInformes />} />
                  <Route path="informes/cheques-tercero" element={<ChequesTercero />} />
                  <Route path="informes/cheques-terceros-cartera" element={<ChequesTercerosCartera />} />
                  <Route path="informes/cheques-propios" element={<ChequesPropios />} />
                  <Route path="informes/cheques-propios-pendientes-acreditar" element={<ChequesPropiosPendientesAcreditar />} />
                  <Route path="informes/movimientos-carteras" element={<MovimientosCarteras />} />
                </Route>
                <Route path="inventario">
                  <Route path="productos" element={<Productos />} />
                  <Route path="productos/nuevo" element={<ProductoForm />} />
                  <Route path="productos/:codigoArticulo" element={<ProductoForm />} />
                  <Route path="transferencias" element={<Transferencias />} />
                  <Route path="transferencias/nuevo" element={<AjusteInventarioForm />} />
                  <Route path="transferencias/:nroFormulario" element={<AjusteInventarioForm />} />
                  <Route path="ramos" element={<Ramos />} />
                  <Route path="ramos/nuevo" element={<RamoForm />} />
                  <Route path="ramos/:codigoRamo" element={<RamoForm />} />
                  <Route path="lineas" element={<Lineas />} />
                  <Route path="lineas/nuevo" element={<LineaForm />} />
                  <Route path="lineas/:codigoLinea" element={<LineaForm />} />
                  <Route path="clases" element={<Clases />} />
                  <Route path="clases/nuevo" element={<ClaseForm />} />
                  <Route path="clases/:codigoClase" element={<ClaseForm />} />
                  <Route path="devoluciones" element={<Devoluciones />} />
                  <Route path="produccion" element={<Produccion />} />
                  <Route path="picking" element={<Picking />} />
                  <Route path="conteo" element={<ConteoStock />} />
                  <Route path="informes" element={<Informes />} />
                  <Route path="informes/stock-deposito" element={<StockPorDeposito />} />
                  <Route path="informes/movimientos-stock" element={<MovimientosStock />} />
                </Route>
                <Route path="compras">
                  <Route path="facturas" element={<FacturasCompra />} />
                  <Route path="facturas/nuevo" element={<FacturaCompraForm />} />
                  <Route path="facturas/:nroFormulario" element={<FacturaCompraDetalle />} />
                  <Route path="proveedores" element={<Proveedores />} />
                  <Route path="proveedores/nuevo" element={<ProveedorForm />} />
                  <Route path="proveedores/:nroProveedor" element={<ProveedorForm />} />
                  <Route path="ramosprov" element={<RamosProv />} />
                  <Route path="ramosprov/nuevo" element={<RamosProvForm />} />
                  <Route path="ramosprov/:codigoRamoProv" element={<RamosProvForm />} />
                  <Route path="informes" element={<ComprasInformes />} />
                  <Route path="informes/cuentas-pagar" element={<CuentasPorPagar />} />
                  <Route path="informes/resumen-cuenta" element={<ResumenCuenta />} />
                  <Route path="informes/resumen-cuenta/:nroProveedor" element={<ResumenCuenta />} />
                  <Route path="informes/libro-iva-compras" element={<LibroIvaCompras />} />
                </Route>
                <Route path="ventas">
                  <Route path="clientes" element={<Clientes />} />
                  <Route path="clientes/nuevo" element={<ClienteForm />} />
                  <Route path="clientes/:nroCliente" element={<ClienteForm />} />
                  <Route path="pedidos" element={<Pedidos />} />
                  <Route path="pedidos/nuevo" element={<PedidosVenta />} />
                  <Route path="pedidos/:pedidoId/editar" element={<PedidosVenta />} />
                  <Route path="pedidos/:pedidoId/ver" element={<PedidosVenta />} />
                  <Route path="cotizaciones" element={<Cotizaciones />} />
                  <Route path="cotizaciones/nuevo" element={<CotizacionesVenta />} />
                  <Route path="cotizaciones/:cotizacionId/editar" element={<CotizacionesVenta />} />
                  <Route path="cotizaciones/:cotizacionId/ver" element={<CotizacionesVenta />} />
                  <Route path="facturas" element={<Facturas />} />
                  <Route path="facturas/nuevo" element={<NuevaFacturaVenta />} />
                  <Route path="facturas/:nroFormulario/ver" element={<NuevaFacturaVenta />} />
                  <Route path="facturas/:nroFormulario/editar" element={<NuevaFacturaVenta />} />
                  <Route path="notas-credito" element={<NotasCredito />} />
                  <Route path="notas-credito/nuevo" element={<NuevaNotaCredito />} />
                  <Route path="vendedores" element={<Vendedores />} />
                  <Route path="vendedores/nuevo" element={<VendedorForm />} />
                  <Route path="vendedores/:codigoVendedor" element={<VendedorForm />} />
                  <Route path="rutas" element={<Rutas />} />
                  <Route path="rutas/nuevo" element={<RutaForm />} />
                  <Route path="rutas/:codigoRuta" element={<RutaForm />} />
                  <Route path="listaprecios" element={<ListaPrecios />} />
                  <Route path="listaprecios/nuevo" element={<ListaPrecioForm />} />
                  <Route path="listaprecios/:nroLista" element={<ListaPrecioForm />} />
                  <Route path="articuloxlistaprecio" element={<ArticuloXListaPrecio />} />
                  <Route path="articuloxlistaprecio/nuevo" element={<ArticuloXListaPrecioForm />} />
                  <Route path="articuloxlistaprecio/:nroLista/:codigoArticulo" element={<ArticuloXListaPrecioForm />} />
                  <Route path="informes" element={<VentasInformes />} />
                  <Route path="informes/cuentas-cobrar" element={<CuentasPorCobrar />} />
                  <Route path="informes/resumen-cuenta" element={<ResumenCuentaVentas />} />
                  <Route path="informes/resumen-cuenta/:nroCliente" element={<ResumenCuentaVentas />} />
                  <Route path="informes/libro-iva-ventas" element={<LibroIvaVentas />} />
                </Route>
                <Route path="consultas" element={<ConsultasPage />} />
                <Route path="sistema">
                  <Route path="usuarios" element={<Usuarios />} />
                  <Route path="usuarios/nuevo" element={<UsuarioForm />} />
                  <Route path="usuarios/:usuario" element={<UsuarioForm />} />
                  <Route path="tipoformulario" element={<TipoFormulario />} />
                  <Route path="tipoformulario/nuevo" element={<TipoFormularioForm />} />
                  <Route path="tipoformulario/:nroTipoFormulario" element={<TipoFormularioForm />} />
                  <Route path="provincias" element={<Provincias />} />
                  <Route path="provincias/nuevo" element={<ProvinciaForm />} />
                  <Route path="provincias/:codigoProvincia" element={<ProvinciaForm />} />
                  <Route path="localidades" element={<Localidades />} />
                  <Route path="localidades/nuevo" element={<LocalidadForm />} />
                  <Route path="localidades/:codLocalidad" element={<LocalidadForm />} />
                  <Route path="movmoneda" element={<MovMoneda />} />
                  <Route path="movmoneda/nuevo" element={<MovMonedaForm />} />
                  <Route path="movmoneda/:tipoMoneda/:fecha" element={<MovMonedaForm />} />
                  <Route path="companias" element={<Companias />} />
                  <Route path="companias/nuevo" element={<CompaniaForm />} />
                  <Route path="companias/:idCompania" element={<CompaniaForm />} />
                  <Route path="caja-usuario" element={<CajaxUsuario />} />
                  <Route path="caja-usuario/nuevo" element={<CajaUsuarioForm />} />
                  <Route path="caja-usuario/:grupoMcp/:usuario" element={<CajaUsuarioForm />} />
                  <Route path="grupo-caja-usuario" element={<GrupoMcpUsuarioPage />} />
                  <Route path="grupo-caja-usuario/nuevo" element={<GrupoMcpUsuarioForm />} />
                </Route>
                <Route path="configuraciones">
                  <Route path="transportes" element={<Transportes />} />
                  <Route path="transportes/nuevo" element={<TransporteForm />} />
                  <Route path="transportes/:nroExpreso" element={<TransporteForm />} />
                  <Route path="impuestos" element={<Impuestos />} />
                  <Route path="impuestos/nuevo" element={<ImpuestoForm />} />
                  <Route path="impuestos/:codigoImpuesto" element={<ImpuestoForm />} />
                  <Route path="ubicaciones" element={<Ubicaciones />} />
                  <Route path="ubicaciones/nuevo" element={<UbicacionForm />} />
                  <Route path="ubicaciones/:nroUbicacion" element={<UbicacionForm />} />
                  <Route path="sucventa" element={<SucVenta />} />
                  <Route path="sucventa/nuevo" element={<SucVentaForm />} />
                  <Route path="sucventa/:nroSuc/:nroTipoFormulario" element={<SucVentaForm />} />
                  <Route path="sucursalesventa" element={<SucursalesVenta />} />
                  <Route path="sucursalesventa/nuevo" element={<SucursalVentaForm />} />
                  <Route path="sucursalesventa/:nroSuc" element={<SucursalVentaForm />} />
                </Route>
                <Route path="contabilidad">
                  <Route path="imputables" element={<Imputables />} />
                  <Route path="imputables/nuevo" element={<ImputableForm />} />
                  <Route path="imputables/:codImputable" element={<ImputableForm />} />
                  <Route path="noimputables" element={<NoImputables />} />
                  <Route path="noimputables/nuevo" element={<NoImputableForm />} />
                  <Route path="noimputables/:nroRubro" element={<NoImputableForm />} />
                  <Route path="estrategia" element={<Estrategia />} />
                  <Route path="estrategia/nuevo" element={<EstrategiaForm />} />
                  <Route path="estrategia/:nint" element={<EstrategiaForm />} />
                </Route>
              </Route>
            </Routes>
          </Router>
          {/* Snackbar con botón de instalación */}
          <Snackbar
                open={snackbarOpen}
                message="¿Querés instalar esta app?"
                action={
                    <Button color="secondary" size="small" onClick={handleInstallClick}>
                        Instalar
                    </Button>
                }
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                onClose={() => setSnackbarOpen(false)}
            />
          {/* Snackbar con botón de actualización */}
          <Snackbar
                open={updateAvailable && !isUpdating}
                message="Hay una nueva versión disponible"
                action={
                    <Button color="primary" size="small" onClick={handleUpdateClick}>
                        Actualizar
                    </Button>
                }
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                onClose={() => {}}
            />
          {/* Snackbar informativo post-actualización */}
          <Snackbar
                open={Boolean(postUpdateVersion)}
                message={`Aplicación actualizada a ${postUpdateVersion}`}
                autoHideDuration={6000}
                onClose={handlePostUpdateClose}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            />
        </AuthProvider>
      </SnackbarProvider>
    </ThemeProvider>
  );
};

export default App; 